<template>
  <div>
    <div style="position: fixed;z-index: 9999999; width: 100%; box-sizing: border-box; height: 52px;padding: 0px 20px;background-color: #FFFFFF; display: flex;align-items: center;">
      <div style="flex: 1; display: flex;align-items: center;">
        <img :src="require('@/assets/logonew.png')" class="logo" />
      </div>
    </div>
    <div style="height: 52px;"></div>
  </div>
</template>

<script>
export default {
  name: "HeaderInterview"
}
</script>

<style scoped>
.logo{
  width: 69px;
  height: 29px;
}
</style>
